import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowStepEditorModel } from '../../models/flow-step-editor.model';
import { FlowStepPanelComponent } from '../flow-step-panel/flow-step-panel.component';

@Component({
  selector: 'app-flow-step-list',
  standalone: true,
  imports: [CommonModule, FlowStepPanelComponent],
  templateUrl: './flow-step-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class FlowStepListComponent {
  @Input() flows: FlowStepEditorModel[] = [];
  @Input() availableStatuses: any[] = [];
  @Input() availableRoles: any[] = [];
  @Input() documentTypes: any[] = [];

  @Output() changed = new EventEmitter<void>();
  @Output() moveUp = new EventEmitter<number>();
  @Output() moveDown = new EventEmitter<number>();
  @Output() remove = new EventEmitter<number>();
}
